import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar'
import Navbar from '../Navbar'
import { useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import Config from '../Config';

function Versionedit() {

    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    let { id } = useParams();

    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    const [version, setVersion] = useState({
        androidVersion: "",
        iOSVersion: "",
        releaseNotesAndroid:"",
        releaseNotesIos:'',
    });
    const [formerror, setError] = useState({});
  
    const getinfo = async (e) => {
        const res = await fetch(`${Config.apiurl}/api/v1/crm/app-version/get-version/${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Cookies.get("a_token")}`,
          },
        });
        if (res.status === 200 ) {
          const data = await res.json();
    
          setVersion(data.data);
    
        } 
        else if(res.status === 401){
          handleUnauthorized();
          getinfo();
        }
        else {
          alert("error");
    
        }
      };


    let name, value;
  
    const handleInputs = (e) => {
      name = e.target.name;
      value = e.target.value;
      setVersion({ ...version, [name]: value });
    };
  
   
  
    const validate = (values) => {
      const errors = {};
      if (!values.androidVersion) {
        errors.androidVersion = "Android version is required!";
      }
  
      if (!values.iOSVersion) {
        errors.iOSVersion = "IOS version is required!";
      }
      if (!values.releaseNotesAndroid) {
        errors.releaseNotesAndroid = "Android version notes is required!";
      }
      if (!values.releaseNotesIos) {
        errors.releaseNotesIos = "IOS version notes is required!";
      }
      return errors;
    };
  
    const PostData = async (e) => {
      e.preventDefault();
      const ress = validate(version);
      setError(ress);
      if (!ress.androidVersion && !ress.iOSVersion && !ress.releaseNotesAndroid && !ress.releaseNotesIos) {
        const res = await fetch(
            `${Config.apiurl}/api/v1/crm/app-version/update-version-info/${id}`,
            {
              method: "PUT",
            body: JSON.stringify({
                androidVersion: version.androidVersion,
                iOSVersion: version.iOSVersion,
                releaseNotesAndroid:version.releaseNotesAndroid,
                releaseNotesIos:version.releaseNotesIos,
              }),
      
              headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
                "Content-type": "application/json; charset=UTF-8",
              },
          })
          if (res.status === 200 ) {
            const data = await res.json();
  
              toast.success("Sucessfully updated version", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setTimeout(() => navigate("/dashboard"), 3000);
  
              
            } 
            else if(res.status === 401){
              handleUnauthorized();
              PostData();
            }
            else {
              toast.error("Something went wrong", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          
      }
    };

    useEffect(()=>{
       getinfo();
    },[])
  return (
    <div className="container-scroller">
    <Navbar />
    <div className="container-fluid page-body-wrapper">
      <Sidebar />
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="row">
            <div className="col-md-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">Version</h4>
                  <p className="card-description">Edit Version</p>
                  <form className="forms-sample" onSubmit={PostData}>
                    {/* <form className="forms-sample"> */}
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">Android version</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="Android version"
                        name="androidVersion"
                        value={version.androidVersion}
                        onChange={handleInputs}
                      />
                      <label style={{ color: "red" }}>
                        {formerror.androidVersion}
                      </label>
                    </div>
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">Android version release notes</label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="Android version release notes"
                        name="releaseNotesAndroid"
                        value={version.releaseNotesAndroid}
                        onChange={handleInputs}
                        rows="2" 
                        ></textarea>
                    
                      <label style={{ color: "red" }}>
                        {formerror.releaseNotesAndroid}
                      </label>
                    </div>
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">IOS version</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="IOS version"
                        name="iOSVersion"
                        value={version.iOSVersion}
                        onChange={handleInputs}
                      />
                      <label style={{ color: "red" }}>{formerror.iOSVersion}</label>
                    </div>
                    <div className="form-group">
                      <label htmlFor="exampleInputUsername1">IOS version release notes</label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="exampleInputUsername1"
                        placeholder="IOS version release notes"
                        name="releaseNotesIos"
                        value={version.releaseNotesIos}
                        onChange={handleInputs}
                        rows="2" 
                        ></textarea>
                      <label style={{ color: "red" }}>{formerror.releaseNotesIos}</label>
                    </div>
                
                    <button
                      type="submit"
                      onClick={PostData}
                      className="btn btn-primary me-2"
                    >
                      Submit
                    </button>
                    <ToastContainer />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Versionedit
